import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import TransferActivityPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/TransferActivityPage";
import ScheduledTransfersPage from "components/pages/TransferActivityPage/components/ScheduledTransfersPage";
import Classes, { TransferTransaction } from "model";
/**
 * @name CaptureTransferActivityMain
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "Transfer Templates" (abi22).
 */
export default function CaptureTransferActivityMain(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);

    const nextID = TransferTransaction.nextID();
    const addedTransfer = TransferTransaction.init({ mapID: nextID, id: nextID, needsApproval: true });

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update(["pendingApprovalTransfers"], [ addedTransfer ])
    .submit();

    // Initalize a new instance of BCMSStateManagerCRUD using the default page ui
    // updating hte content, scheduledTransfers and Accordion properties
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    // Sets the component to be used for the content
    .update([ "content" ], ScheduledTransfersPage)
    // Sets the tab to be selected
    .update([ "scheduledTransfers", "isActive" ], true)
    .submit();

    // Return the TransferActivityPage passing the ui variable
    return <TransferActivityPage data={ data } ui={ ui } />
}